import React, { useImperativeHandle, forwardRef, useState } from "react";
import propsTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogSlide = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    changeStatus() {
      handleChangeStatus();
    },
  }));

  const handleChangeStatus = () => {
    setOpen(!open);
  };

  return (
    <Dialog
      className={props.className}
      open={open}
      TransitionComponent={Transition}
      fullWidth={props.fullWidth}
      maxWidth={props.maxWidth}
      keepMounted
      onClose={() => (props.onBackClose ? handleChangeStatus() : false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      {props.children}
    </Dialog>
  );
});

DialogSlide.propsTypes = {
  className: propsTypes.string,
  maxWidth: propsTypes.string,
  fullWidth: propsTypes.bool,
  onBackClose: propsTypes.bool,
  children: propsTypes.elementType,
};

DialogSlide.defaultProps = {
  maxWidth: "lg",
  fullWidth: false,
  onBackClose: true,
};

export default DialogSlide;
